import system from "./system";

const components = {
  button: {
    fontFamily: system.fonts.body,
    color: "#fff",
    border: "1px solid #fff",
    backgroundColor: "transparent",
    borderRadius: "999px",
    "&:hover": { backgroundColor: "rgba(191, 33, 32, 0.24)" },
  },
  divider: { backgroundColor: "rgba(255,255,255,0.28)" },
  pageHeader: {
    fontFamily: system.fonts.heading,
    color: "#fff",
    fontSize: "42px",
    textShadow: "0 2px 0 #000, 0 0 8px rgba(255,255,255,.6)",
  },
  sectionHeader: {
    fontFamily: system.fonts.heading,
    color: "#fff",
    fontSize: "38px",
    lineHeight: 1.2,
    textAlign: "center",
    textShadow: "0 2px 0 #000, 0 0 8px rgba(255,255,255,.45)",
  },
  footer: {
    color: "#fff",
    fontFamily: system.fonts.body,
    fontSize: "15px",
    letterSpacing: "0.08em",
  },
  loading: { color: "#fff" },
  dialog: {
    title: { fontFamily: system.fonts.body, fontSize: "16px", color: "#fff" },
    description: { fontFamily: system.fonts.body, fontSize: "14px", color: "#fff" },
    width: "84%",
    backgroundColor: system.colors.background.dialog,
    button: { color: "#fff" },
  },
  newsItem: {
    text: {
      title: { fontFamily: system.fonts.body, color: "#fff", fontSize: "14px" },
      date: { fontFamily: system.fonts.body, color: "#c8c8c8", fontSize: "12px" },
    },
  },
};

export default components;
